'use client'
import { styled } from '../config'
import React from 'react'

function Svg(props) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M1.95073 5.32429C1.80185 5.67876 1.73645 6.05379 1.70352 6.45682C1.66667 6.90781 1.66668 7.46144 1.66669 8.13224V11.8678C1.66668 12.5386 1.66667 13.0922 1.70352 13.5432C1.74179 14.0116 1.82392 14.4422 2.03 14.8466C2.34958 15.4738 2.85951 15.9838 3.48672 16.3034C3.89117 16.5094 4.32175 16.5916 4.79017 16.6298C5.24116 16.6667 5.79478 16.6667 6.46557 16.6667H13.5344C14.2052 16.6667 14.7589 16.6667 15.2099 16.6298C15.6783 16.5916 16.1089 16.5094 16.5133 16.3034C17.1405 15.9838 17.6505 15.4738 17.97 14.8466C18.1761 14.4422 18.2583 14.0116 18.2965 13.5432C18.3334 13.0922 18.3334 12.5386 18.3334 11.8678V8.13224C18.3334 7.46144 18.3334 6.90781 18.2965 6.45682C18.2636 6.05378 18.1982 5.67875 18.0493 5.32428L12.1108 10.183C10.8829 11.1877 9.1171 11.1877 7.88922 10.183L1.95073 5.32429Z"
        fill="#9B9B9B"
      />
      <path
        d="M17.0187 4.01409C16.8608 3.89398 16.6918 3.78761 16.5133 3.69666C16.1089 3.49058 15.6783 3.40844 15.2099 3.37017C14.7589 3.33333 14.2052 3.33333 13.5344 3.33334H6.46561C5.79481 3.33333 5.24116 3.33333 4.79017 3.37017C4.32175 3.40844 3.89117 3.49058 3.48672 3.69666C3.30821 3.78761 3.13919 3.89399 2.98137 4.0141L8.94461 8.89312C9.55856 9.39544 10.4415 9.39544 11.0554 8.89312L17.0187 4.01409Z"
        fill="#9B9B9B"
      />
    </svg>
  )
}

export const Email = styled(Svg)
